import React from 'react'
import PropTypes from 'prop-types';
import { DaysInfoStyled } from './styled';

const DaysInfo = ({ days, color }) => {
    return (
        <DaysInfoStyled
            color={color}
        >
            {days}
        </DaysInfoStyled>
    )
}

DaysInfo.propTypes = {
    days: PropTypes.number,
}

export default DaysInfo